// extracted by mini-css-extract-plugin
export default {"back_btn":"manage-style_back_btn__bBnm8"};